import { render } from "./AddAudience.vue?vue&type=template&id=527bf85a&scoped=true"
import script from "./AddAudience.vue?vue&type=script&lang=js"
export * from "./AddAudience.vue?vue&type=script&lang=js"

import "./AddAudience.vue?vue&type=style&index=0&id=527bf85a&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527bf85a"]])

export default __exports__